import React, { Component } from 'react';
import './HatPdaDialog.scss';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      color: '#1f1f1f',
      letterSpacing: '0.5px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontSize: '1.8rem',
      margin: 0,
      paddingTop: '2.2rem',
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography className="hat-pda-dialog-title" variant="h6">
        {children}
      </Typography>
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
          {<i className="material-icons">close</i>}
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(() => ({
  root: {
    padding: '2.2rem',
    color: '#505050',
    fontSize: '1.4rem',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    fontSize: '1.6rem',
    padding: theme.spacing(2),
    justifyContent: 'center',
    paddingBottom: '2.2rem',
  },
}))(MuiDialogActions);

class HatPdaDialog extends Component<IHatPdaDialog> {
  handleClose = () => {
    this.props.switchDialog(false);
  };

  learnMore = () => {
    window.open('https://www.hubofallthings.com/main/what-is-the-hat');
    this.props.switchDialog(false);
  };

  render() {
    return (
      <div>
        <Dialog onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={this.props.open}>
          <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
            What is a HAT Personal Data Account (PDA)?
          </DialogTitle>
          <DialogContent>
            A HAT Personal Data Account is the equivalent of a bank account, but for data.
            <br />
            <br />
            With the HAT PDA, a HAT owner can give the data they own to websites and mobile applications in return for
            services and benefits, at the touch of a few buttons.
            <br />
            <br />
            The HAT PDA also replaces the need for user accounts on mobile apps and websites. It is already referenced
            globally as a best in class solution on the Internet for individual data ownership and rights.
            <br />
            <br />
            The HAT Personal Data Account technology is more than just a centralised bank account technology. It is a
            decentralised private microserver for creating new data through machine learning and analytics.
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.learnMore}
              style={{
                fontSize: '1.4rem',
                color: 'white',
                backgroundColor: '#6297B1',
                borderRadius: '11px',
                width: '14rem',
                height: '4.8rem',
                margin: '1.5rem auto',
              }}
              color="primary"
            >
              Learn more
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

interface IHatPdaDialog {
  open: boolean;
  switchDialog: any;
}

export default HatPdaDialog;
